import React, { useState, useEffect } from "react";
import "./EditInsuranceModal.css";

const EditInsuranceModal = ({
  insuranceData = [],
  onSave,
  onCancel,
  setShowEditModal,
}) => {
  const [formData, setFormData] = useState([{
    provider: "",
    groupNumber: "",
    memberNumber: "",
  }]);

  const [editingIndex, setEditingIndex] = useState(null);

  useEffect(() => {
    if (editingIndex !== null) {
      setFormData(insuranceData[editingIndex]);
    } else {
      setFormData({ provider: "", groupNumber: "", memberNumber: "" });
    }
  }, [editingIndex]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = () => {
    const updatedList = [...insuranceData];

    if (editingIndex !== null) {
      updatedList[editingIndex] = formData;
    } else {
      updatedList.push(formData);
    }
    
    onSave(updatedList);
    setFormData({ provider: "", groupNumber: "", memberNumber: "" });
    setEditingIndex(null);
  };

  const handleEdit = (index) => {
    setEditingIndex(index);
  };

  const handleAdd = () => {
    const newInsurance = { provider: "", groupNumber: "", memberNumber: ""}
    setFormData([...formData,newInsurance]);
  }

  const handleRemove = (index) => {
    const updatedList = insuranceData.filter((_, i) => i !== index);
    onSave(updatedList);
    if (editingIndex === index) {
      setEditingIndex(null);
      setFormData({ provider: "", groupNumber: "", memberNumber: "" });
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h2>{editingIndex !== null ? "Edit Insurance" : "Add Insurance"}</h2>
        </div>

        <div className="form-group">
          <label>Insurance Company</label>
          <input
            type="text"
            name="provider"
            value={formData.provider}
            onChange={handleChange}
            placeholder="e.g., United Healthcare"
          />
        </div>
        <div className="row">
          <div className="form-group col-md-6">
            <label>Group Member</label>
            <input
              type="text"
              name="groupNumber"
              value={formData.groupNumber}
              onChange={handleChange}
              placeholder="e.g., G123456"
            />
          </div>
          <div className="form-group col-md-6">
            <label>Member Number</label>
            <input
              type="text"
              name="memberNumber"
              value={formData.memberNumber}
              onChange={handleChange}
              placeholder="e.g., M837373"
            />
          </div>
        </div>

        <div className="add-insurance">
          <button className="add-insurance-button" onClick={handleSave}>
            <span className="icon-wrapper">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="plus-icon"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#2563eb"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <line x1="12" y1="5" x2="12" y2="19" />
                <line x1="5" y1="12" x2="19" y2="12" />
              </svg>
            </span>
            {editingIndex !== null ? "Update Insurance" : "Add Insurance"}
          </button>
        </div>

        <hr />

        <div className="insurance-list">
          <div className="table-header">
            <span>#</span>
            <span>Insurance Company</span>
            <span>Group Member</span>
            <span>Member Number</span>
            <span>Action</span>
          </div>
          {insuranceData.map((item, index) => (
            <div key={index} className="table-row">
              <span>{index + 1}</span>
              <span>{item.provider}</span>
              <span>{item.groupNumber}</span>
              <span>{item.memberNumber}</span>
              <div className="action-buttons">
                <button className="icon-button edit" onClick={() => handleEdit(index)}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="icon"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path d="M12 20h9" />
                    <path d="M16.5 3.5a2.121 2.121 0 1 1 3 3L7 19l-4 1 1-4 12.5-12.5z" />
                  </svg>
                  Edit
                </button>
                <button className="icon-button delete" onClick={() => handleRemove(index)}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="icon"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <polyline points="3 6 5 6 21 6" />
                    <path d="M19 6l-2 14H7L5 6" />
                    <path d="M10 11v6M14 11v6" />
                  </svg>
                  Remove
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="button-group">
          <button className="save-button-insurance-modal" onClick={handleSave}>
            Save
          </button>
          <button
            className="cancel-button-insurance-modal"
            onClick={() => {
              setShowEditModal(false);
              setEditingIndex(null);
              setFormData({ provider: "", groupNumber: "", memberNumber: "" });
            }}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditInsuranceModal;